<div class="d-flex flex-column flex-shrink-0 p-3 text-white bg-dark sidebar" [ngClass]="{ collapsed: isCollapsed }">
  <a href="/" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none">
    <i class="bi bi-speedometer2 fs-4 me-2"></i>
    <span class="fs-5 d-none d-md-inline">Dashboard</span>
  </a>

  <hr class="bg-secondary" />

  <ul class="nav nav-pills flex-column mb-auto">
    <li class="nav-item">
      <a href="#" class="nav-link text-white active" aria-current="page">
        <i class="bi bi-house-door-fill me-2"></i>
        <span class="d-none d-md-inline">Home</span>
      </a>
    </li>
    <li>
      <a href="#" class="nav-link text-white">
        <i class="bi bi-people-fill me-2"></i>
        <span class="d-none d-md-inline">Users</span>
      </a>
    </li>
    <li>
      <a href="#" class="nav-link text-white">
        <i class="bi bi-compass me-2"></i>
        <span class="d-none d-md-inline">Cruises</span>
      </a>
    </li>
    <li>
      <a href="#" class="nav-link text-white">
        <i class="bi bi-gear-fill me-2"></i>
        <span class="d-none d-md-inline">Settings</span>
      </a>
    </li>
  </ul>

  <hr class="bg-secondary" />

  <div class="dropdown">
    <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" data-bs-toggle="dropdown">
      <img src="https://via.placeholder.com/32" alt="profile" width="32" height="32" class="rounded-circle me-2" />
      <strong class="d-none d-md-inline">User</strong>
    </a>
    <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
      <li><a class="dropdown-item" href="#">Profile</a></li>
      <li><a class="dropdown-item" href="#">Settings</a></li>
      <li><hr class="dropdown-divider" /></li>
      <li><a class="dropdown-item" href="#">Sign out</a></li>
    </ul>
  </div>

  <button class="btn btn-sm btn-outline-light mt-3" (click)="toggleSidebar()">
    <i class="bi" [ngClass]="isCollapsed ? 'bi-arrow-bar-right' : 'bi-arrow-bar-left'"></i>
  </button>
</div>
